import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatNumber } from "@signolteam/shared/units-of-measure";
import { SIGNOL_COLOURS } from "@signolteam/shared/colours";
import { DataAccessPage } from "@src/pages/manager/index.js";
import Icon from "@src/components/atoms/Icon.jsx";

let defaultMetadata = {
  me_1_power_check: 12,
  me_1_power_check_description: "Description for ME 1 Power Check",
  me_1_power_check_status: "VALID",

  me_consumption_check: 11.9,
  me_consumption_check_description: "Description for ME Consumption Check",
  me_consumption_check_status: "VALID",

  logged_speed_check: 10.5,
  logged_speed_check_description: "Description for Logged Speed Check",
  logged_speed_check_status: "VALID",

  ae_power_check: 9.8,
  ae_power_check_description: "Description for AE Power Check",
  ae_power_check_status: "VALID",

  ae_consumption_check: 9.5,
  ae_consumption_check_description: "Description for AE Consumption Check",
  ae_consumption_check_status: "VALID",

  electrical_consumer_hours_check: 8.2,
  electrical_consumer_hours_check_description:
    "Description for Electrical Consumer Running Hours Check",
  electrical_consumer_hours_check_status: "VALID",
};

const colourMapping = {
  EXEMPT: "100",
  VALID: "500",
  MISSING: "100",
  IMPOSSIBLE: "100",
  UNEXPECTED: "100",
};

const getStateIcon = (state) => {
  const stateIcon = {
    EXEMPT: {
      name: "hqdsExempt",
      colour: "neutral",
      colourShade: 300,
    },
    VALID: {
      name: "hqdsValid",
      colourShade: 400,
    },
    MISSING: {
      name: "hqdsFail",
      colourShade: 200,
    },
    IMPOSSIBLE: {
      name: "hqdsFail",
      colourShade: 200,
    },
    UNEXPECTED: {
      name: "hqdsFail",
      colourShade: 200,
    },
  }[state];
  return stateIcon;
};
export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
  dc,
  dcExists,
}) {
  // find all the metadata fields that end with "_check" and use them to create the data for the graph
  const allData = Object.keys(metadata)
    .filter((key) => key.endsWith("_check"))
    .map((key) => {
      const label = key.replace(/_/g, " ").replace(" check", "");
      const checkName = key.replace("_check", "");
      const statusKey = key.replace("_check", "_check_status");
      const status = metadata[statusKey] || "OK";
      const descrKey = key.replace("_check", "_check_description");
      const description = metadata[descrKey] || "";
      return {
        name: label,
        checkName,
        mobileName: label,
        value: Number(metadata[key]),
        status: description.includes("MISSING") ? "MISSING" : status,
        description: description,
      };
    });

  const data = allData.filter((item) => item.status !== "EXEMPT");
  // sort data so that VALID items are at the top
  data.sort((a, b) => {
    if (a.status === "VALID" && b.status !== "VALID") {
      return -1;
    } else if (a.status !== "VALID" && b.status === "VALID") {
      return 1;
    } else {
      return 0;
    }
  });

  // successfull if there's at most one item that is not VALID
  // this should be in the metadata passed to the graph, but for now we can calculate it here
  const isSuccessful =
    data.filter((item) => item.status !== "VALID").length <= 1;

  return (
    <div className="w-full pt-4">
      {isSuccessful ? (
        <div>{dc("captain__behaviours__graphs__hqds__successful_message")}</div>
      ) : (
        <div>
          {dc("captain__behaviours__graphs__hqds__unsuccessful_message")}
        </div>
      )}
      <div className="w-full flex flex-col md:grid md:grid-cols-2 gap-4 pt-4">
        {data.map((item) => {
          const { name, checkName, status, description } = item;
          const {
            name: iconName,
            colour: iconColour,
            colourShade: iconColourShade,
          } = getStateIcon(status);
          const colourToUse = status === "EXEMPT" ? "neutral" : bvrColour.name;
          return (
            <div
              className={`rounded-md p-4 bg-${colourToUse}-${colourMapping[status]}`}
              key={name}
            >
              <div className="">
                <div className="flex-1 flex justify-between">
                  <div className="flex-1">
                    <div className="font-bold">
                      {dc(
                        `captain__behaviours__graphs__hqds__${checkName.toLowerCase()}__title`,
                      )}
                    </div>
                    <div className="text-sm">
                      Status:{" "}
                      <span className="capitalize">
                        {status === "EXEMPT"
                          ? "Not required"
                          : status.toLowerCase()}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 flex justify-end py-3">
                    <Icon
                      key={bvrColour.name}
                      size="lg"
                      name={iconName}
                      inline
                      textColor={iconColour || colourToUse}
                      textColorShade={status === "EXEMPT" ? 800 : 900}
                      backgroundColor={iconColour || colourToUse}
                      backgroundColorShade={
                        iconColourShade ||
                        (status === "EXEMPT" ? 500 : colourMapping[status])
                      }
                    />
                  </div>
                </div>
                {dcExists(
                  `captain__behaviours__graphs__hqds__${item.description.toLowerCase()}`,
                ) && (
                  <div
                    className={`text-sm mt-2 border-2 p-2 bg-${colourToUse}-200 border-${colourToUse}-500`}
                  >
                    {dc(
                      `captain__behaviours__graphs__hqds__${item.description.toLowerCase()}`,
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
